export const TRANSACTION_COSTS = 55;
export const DEFAULT_PARTNER_MARGIN = 30;
export const FINANCIAL_STRUCTURE = 11000;
